import {
  IconAddressBook,
  IconMail,
  IconMessageDots,
  IconBook,
  IconArrowRight,
} from "@tabler/icons-react";
import styles from "./Support.module.css";

export default function ContactOptionsCard({ onOpenContactModal }) {
  return (
    <div className={styles.sideCard}>
      <div className={styles.sideCardHeader}>
        <div className={styles.sideCardIcon}>
          <IconAddressBook size={16} />
        </div>
        <span className={styles.sideCardTitle}>Contact Options</span>
      </div>
      <div className={styles.sideCardBody}>
        <div className={styles.contactList}>
          <a href="mailto:support@awasource.com" className={styles.contactOpt}>
            <div
              className={styles.contactOptIcon}
              style={{ background: "#eff2ff", color: "var(--blue)" }}
            >
              <IconMail size={17} />
            </div>
            <div className={styles.contactOptInfo}>
              <div className={styles.contactOptName}>Email Support</div>
              <div className={styles.contactOptSub}>support@awasource.com</div>
            </div>
            <IconArrowRight className={styles.contactOptArrow} size={15} />
          </a>

          <button className={styles.contactOpt} onClick={onOpenContactModal}>
            <div
              className={styles.contactOptIcon}
              style={{ background: "#ecfdf5", color: "#059669" }}
            >
              <IconMessageDots size={17} />
            </div>
            <div className={styles.contactOptInfo}>
              <div className={styles.contactOptName}>Live Chat</div>
              <div className={styles.contactOptSub}>
                Pro &amp; Enterprise plans
              </div>
            </div>
            <IconArrowRight className={styles.contactOptArrow} size={15} />
          </button>
        </div>
      </div>
    </div>
  );
}
